import React, { FunctionComponent } from "react";
import BusinessIcon from "@material-ui/icons/Business";
import SchoolIcon from "@material-ui/icons/School";

import { EnterButton } from "./EnterButton";
import { LoginWindow } from "$components/LoginWindow";
import { Title } from "$components/Title";

import { IComponentProps } from "./interfaces";
import styles from "./styles.module.scss";
import { LoadingSpinner } from "$components/LoadingSpinner";

export const Login: FunctionComponent<IComponentProps> = (
  {
    loginAsCompanyUserLink,
    translations,
    loginWithGoogle
  }
) => ( 
  <LoginWindow rightContainerClassName={styles.rightWindowContainer}>
    <section className={styles.rightContainer}>
      {
        !translations ? <LoadingSpinner/> :
          <>
            <Title className={styles.title}>{translations.title}</Title>

            <EnterButton
              className={styles.applicantCard}
              Icon={SchoolIcon}
              label={translations.fiubaLogin}
              onClick={loginWithGoogle}
            />

            <EnterButton
              className={styles.companyCard}
              Icon={BusinessIcon}
              label={translations.companyLogin}
              link={loginAsCompanyUserLink}
            />
          </>
      }
    </section>
  </LoginWindow>
);
